export default function loader(src, idKey) {
  return new Promise((resolve, reject) => {
    var js,
      body = document.getElementsByTagName('body')[0];
    var preJs = document.getElementById(idKey);
    if (preJs) {
      if (preJs.getAttribute('loaded') == 1) {
        return resolve();
      } else {
        body.removeChild(preJs);
      }
    }
    js = document.createElement('script');
    js.id = idKey;
    js.src = src;
    js.setAttribute('loaded', '0');
    js.onload = function onload() {
      js.setAttribute('loaded', '1');
      resolve();
    };
    js.onerror = function onerror() {
      reject();
    };
    body.appendChild(js);
  });
}
